export default "__VITE_ASSET__Nceest5l__"